import { getUserAllData } from '../../Constants/index';
import moment from 'moment/moment';

export function formatDate(dateString) {
  if (!dateString) {
    return '';
  }

  let userAllData = getUserAllData();
  const dateShortFormat = userAllData[0]?.dateShort.toUpperCase() || 'DD-MM-YYYY';
  // const dateLongFormat = userAllData[0]?.dateLong || 'DD-MM-YYYY HH:mm:ss';
  if (dateString === '1900-01-01T00:00:00') {
    return '';
  } else if (moment(dateString, 'ddd MMM DD YYYY HH:mm:ss [GMT]Z (z)', true).isValid()) {
    return moment(dateString, 'ddd MMM DD YYYY HH:mm:ss [GMT]Z (z)').format(dateShortFormat);
  } else if (moment(dateString, 'YYYY-MM-DD', true).isValid()) {
    return moment(dateString, 'YYYY-MM-DD').format(dateShortFormat);
  } else if (
    moment(
      dateString,
      ['YYYY-MM-DDTHH:mm:ss.SSS', 'YYYY-MM-DDTHH:mm:ss.SS', 'YYYY-MM-DDTHH:mm:ss.S', 'YYYY-MM-DDTHH:mm:ss'],
      true
    ).isValid()
  ) {
    return moment(dateString, ['YYYY-MM-DDTHH:mm:ss.SSS', 'YYYY-MM-DDTHH:mm:ss.SS', 'YYYY-MM-DDTHH:mm:ss.S', 'YYYY-MM-DDTHH:mm:ss']).format(
      'DD-MM-YYYY HH:mm:ss'
    );
  } else {
    return '';
  }
}
export function formatDateTime(dateString) {
  if (!dateString) {
    return '';
  }

  // let userAllData = getUserAllData();
  // const dateLongFormat = userAllData[0]?.dateLong || 'DD-MM-YYYY HH:mm:ss';
  if (moment(dateString, 'ddd MMM DD YYYY HH:mm:ss [GMT]Z (z)', true).isValid()) {
    return moment(dateString, 'ddd MMM DD YYYY HH:mm:ss [GMT]Z (z)').format('DD-MM-YYYY HH:mm:ss');
  } else {
    return '';
  }
}

export function getCurrentDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const date = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  return `${date}-${month}-${year}_${hours}-${minutes}`;
}

export function getHoursMinutes(dateString) {
  if (!dateString) {
    return ''; // Return blank if dateString doesn't exist
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return ''; // Return blank if dateString is invalid
  }

  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Convert 24-hour format to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'

  // Pad minutes with leading zero if needed
  minutes = minutes < 10 ? '0' + minutes : minutes;

  return `${hours}:${minutes} ${ampm}`;
}

export function getNotificationTime(dateString) {
  // Handle null, undefined, or empty string
  if (!dateString) {
    return ''; // Return blank if the input is null or empty
  }

  const givenTime = new Date(dateString); // Parse the given time

  // Check if the given time is an invalid date
  if (isNaN(givenTime.getTime())) {
    return ''; // Return blank if the date is invalid
  }

  const currentTime = new Date(); // Get current time
  const timeDifference = Math.floor((currentTime - givenTime) / 1000); // Difference in seconds

  if (timeDifference < 60) {
    return 'Just now'; // Less than 1 minute
  } else if (timeDifference < 3600) {
    const minutes = Math.floor(timeDifference / 60);
    return `${minutes} mint${minutes > 1 ? 's' : ''} ago`; // Less than 1 hour
  } else if (timeDifference < 86400) {
    const hours = Math.floor(timeDifference / 3600);
    return `${hours} hour${hours > 1 ? 's' : ''} ago`; // Less than 1 day
  } else {
    const days = Math.floor(timeDifference / 86400);
    return `${days} day${days > 1 ? 's' : ''} ago`; // More than 1 day
  }
}
